import { type FC } from "react";
import CloudOff from "@mui/icons-material/CloudOff";
import Refresh from "@mui/icons-material/Refresh";
import { Button } from "@mui/material";

import { InfoPage } from "../../../shared/components/info-page/info-page";
import { InfoPageIllustration } from "../../../shared/components/info-page/info-page-illustration";
import { InfoPageLayout } from "../../../shared/components/info-page/info-page-layout";
import { SignOutButton } from "../components/sign-out-button";

interface SessionCheckFailedPageProps {
  onRetry: () => void;
}

export const SessionCheckFailedPage: FC<SessionCheckFailedPageProps> = ({ onRetry }) => (
  <InfoPageLayout>
    <InfoPage
      title="Не удалось проверить вход"
      message="Проверьте подключение к сети и повторите попытку"
      illustration={<InfoPageIllustration icon={CloudOff} />}
      actions={
        <>
          <SignOutButton />
          <Button
            variant="contained"
            color="primary"
            startIcon={<Refresh />}
            onClick={onRetry}
          >
            Повторить
          </Button>
        </>
      }
    />
  </InfoPageLayout>
);
